import CheckedIconPin from './component'

export default CheckedIconPin